/* Trendy Card theme — no dependencies */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var T = window.theme || {};

  function store(k, v) { try { if (v === undefined) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function load(k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } }

  function money(cents) {
    var fmt = T.moneyFormat || 'Rs.{{amount}}';
    var n = (cents / 100);
    var plain = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      return k.indexOf('no_decimals') > -1 ? noDec : plain;
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  var toastTimer;
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2400);
  }

  /* ---------- Dark / light mode ---------- */
  function currentTheme() {
    var a = document.documentElement.getAttribute('data-theme');
    if (a) return a;
    return window.matchMedia && matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  $$('[data-theme-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var next = currentTheme() === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', next);
      try { localStorage.setItem('tc-theme', next); } catch (e) {}
      toast(next === 'dark' ? 'Dark mode on' : 'Light mode on');
    });
  });

  /* ---------- Overlays ---------- */
  var scrim = $('[data-scrim]');
  var drawer = $('#CartDrawer');
  var menu = $('[data-menu-drawer]');
  function openEl(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); el.inert = false; scrim && scrim.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeAll() {
    [drawer, menu].forEach(function (el) { if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); el.inert = true; } });
    scrim && scrim.classList.remove('is-open'); document.body.style.overflow = '';
  }
  scrim && scrim.addEventListener('click', closeAll);
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  $$('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { openEl(menu); }); });

  /* ---------- Cart ---------- */
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = cart.item_count; b.setAttribute('data-n', cart.item_count); });
    $$('[data-cart-total-top],[data-cart-subtotal],[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
    var c = $('[data-cart-count-text]'); if (c) c.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    var box = $('[data-cart-items]'), foot = $('[data-cart-foot]');
    if (!box) return;
    if (!cart.item_count) {
      box.innerHTML = '<div class="empty"><p>Your cart is empty.</p><a class="btn btn--brand" href="' + (T.routes.root || '/') + 'collections/all">Start shopping</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    box.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="line__v">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="line">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') +
        '<div><a class="line__t" href="' + it.url + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="qty qty--sm" style="margin-top:6px"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><input type="number" value="' + it.quantity + '" readonly aria-label="Quantity"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
        '<div class="line__p">' + money(it.final_line_price) + '<button type="button" class="line__rm" data-line="' + (i + 1) + '" data-q="0">Remove</button></div>' +
        '</div>';
    }).join('');
  }
  function fetchCart() { return fetch((T.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }); }
  function changeLine(line, qty) {
    return fetch((T.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(items) {
    return fetch((T.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
    }).then(function () { return fetchCart(); }).then(function () { openEl(drawer); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line]');
    if (b) { e.preventDefault(); changeLine(+b.getAttribute('data-line'), Math.max(0, +b.getAttribute('data-q'))); return; }
    var open = e.target.closest('[data-open-cart]');
    if (open && drawer && !document.body.classList.contains('template-cart')) { e.preventDefault(); fetchCart(); openEl(drawer); return; }
    var q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault(); q.disabled = true;
      addToCart([{ id: +q.getAttribute('data-quick-add'), quantity: 1 }])
        .then(function () { toast('Added to cart'); })
        .catch(function (err) { toast(err.message); })
        .finally(function () { q.disabled = false; });
    }
  });

  /* ---------- Product page ---------- */
  var pdp = $('[data-product]');
  if (pdp) {
    var json = $('#' + pdp.getAttribute('data-product-json-id'));
    var data = json ? JSON.parse(json.textContent) : { variants: [] };
    var form = $('[data-product-form]', pdp);
    var idInput = $('[data-variant-id]', pdp);
    var addBtn = $('[data-add-btn]', pdp), addLbl = $('[data-add-label]', pdp), buyNow = $('[data-buy-now]', pdp);
    var priceWrap = $('[data-price-wrap]', pdp), stock = $('[data-stock]', pdp), saleTag = $('[data-sale-tag]', pdp);

    function showMedia(id) {
      if (!id) return;
      $$('.gallery__slide', pdp).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') == id); });
      $$('.gallery__thumb', pdp).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') == id); });
    }
    $$('.gallery__thumb', pdp).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

    function selectedOptions() {
      var vals = [];
      $$('[data-opt-index]:checked', pdp).forEach(function (i) { vals[+i.getAttribute('data-opt-index')] = i.value; });
      return vals;
    }
    function updateVariant() {
      var opts = selectedOptions();
      opts.forEach(function (v, i) { var l = $('[data-opt-label="' + i + '"]', pdp); if (l) l.textContent = v; });
      var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      if (!v) { addBtn.disabled = true; addLbl.textContent = 'Unavailable'; if (buyNow) buyNow.disabled = true; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available; if (buyNow) buyNow.disabled = !v.available;
      addLbl.textContent = v.available ? 'Add to cart' : 'Sold out';
      var off = v.compare > v.price ? Math.floor((v.compare - v.price) * 100 / v.compare) : 0;
      priceWrap.innerHTML = '<div class="price' + (off ? ' price--sale' : '') + '"><b class="price__now">' + money(v.price) + '</b>' +
        (off ? '<s class="price__was">' + money(v.compare) + '</s><span class="price__save">Save ' + off + '%</span>' : '') + '</div>';
      if (saleTag) { saleTag.hidden = !off; saleTag.textContent = '-' + off + '%'; }
      stock.classList.toggle('is-out', !v.available);
      stock.textContent = v.available ? 'In stock, ready to ship' : 'Sold out';
      if (v.media) showMedia(v.media);
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    $$('[data-opt-index]', pdp).forEach(function (i) { i.addEventListener('change', updateVariant); });

    $$('[data-qty]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('input[name="quantity"]', pdp);
        inp.value = Math.max(1, (+inp.value || 1) + +b.getAttribute('data-qty'));
      });
    });

    form && form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && submitter.name === 'buy_now') {
        // Go straight to checkout with this item
        e.preventDefault();
        var qty = +$('input[name="quantity"]', pdp).value || 1;
        location.href = (T.routes.root || '/') + 'cart/' + idInput.value + ':' + qty;
        return;
      }
      e.preventDefault();
      addBtn.disabled = true;
      addToCart([{ id: +idInput.value, quantity: +$('input[name="quantity"]', pdp).value || 1 }])
        .then(function () { toast('Added to cart'); })
        .catch(function (err) { toast(err.message); })
        .finally(function () { addBtn.disabled = false; });
    });
  }

  /* Related products */
  var rec = $('[data-recommendations]');
  if (rec && !$('[data-rec-inner]', rec)) {
    fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = d.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) { rec.innerHTML = inner.innerHTML; paintWishes(); }
    }).catch(function () {});
  }

  /* ---------- Wishlist (saved in this browser) ---------- */
  var wishes = load('tc-wishlist', []);
  function paintWishes() {
    $$('[data-wish]').forEach(function (b) { b.classList.toggle('is-on', wishes.indexOf(b.getAttribute('data-wish')) > -1); });
    $$('[data-wish-count]').forEach(function (b) { b.textContent = wishes.length; b.setAttribute('data-n', wishes.length); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), i = wishes.indexOf(h);
    if (i > -1) { wishes.splice(i, 1); toast('Removed from wishlist'); } else { wishes.push(h); toast('Saved to wishlist'); }
    store('tc-wishlist', wishes); paintWishes();
  });
  paintWishes();

  var wGrid = $('[data-wishlist-grid]');
  if (wGrid) {
    if (!wishes.length) { $('[data-wishlist-empty]').hidden = false; }
    Promise.all(wishes.map(function (h) {
      return fetch((T.routes.root || '/') + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      list = list.filter(Boolean);
      if (!list.length) { $('[data-wishlist-empty]').hidden = false; return; }
      wGrid.innerHTML = list.map(function (p) {
        var v = p.variants[0], off = p.compare_at_price > p.price ? Math.floor((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
        return '<article class="card"><a href="' + p.url + '" class="card__media">' + (img ? '<img class="card__img" src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          (off ? '<span class="tag">-' + off + '%</span>' : '') +
          '<button type="button" class="wish is-on" data-wish="' + p.handle + '" aria-label="Remove from wishlist"><svg class="i" viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10Z"/></svg></button>' +
          '<div class="card__body"><h3 class="card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></h3>' +
          '<div class="price"><b class="price__now">' + money(p.price) + '</b>' + (off ? '<s class="price__was">' + money(p.compare_at_price) + '</s>' : '') + '</div>' +
          (p.available && p.variants.length === 1 ? '<button type="button" class="btn btn--soft btn--block" data-quick-add="' + v.id + '">Add to cart</button>' : '<a class="btn btn--soft btn--block" href="' + p.url + '">View product</a>') +
          '</div></article>';
      }).join('');
    });
  }

  /* ---------- Tabs (home product tabs) ---------- */
  $$('[data-tabs]').forEach(function (sec) {
    var tabs = $$('[role="tab"]', sec);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) {
          var on = x === t; x.setAttribute('aria-selected', on);
          var p = $('#' + x.getAttribute('aria-controls')); if (p) p.hidden = !on;
        });
      });
    });
  });

  /* ---------- Sign in / create account tabs ---------- */
  function showAuth(name) {
    $$('[data-auth-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-auth-panel') !== name; });
    $$('.seg [data-auth-tab]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-auth-tab') === name); });
  }
  $$('[data-auth-tab]').forEach(function (b) { b.addEventListener('click', function () { showAuth(b.getAttribute('data-auth-tab')); }); });
  $$('[data-show-recover]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); showAuth('recover'); }); });
  if ($('[data-auth-panel]')) {
    if (location.hash === '#recover') showAuth('recover');
    else if (location.hash === '#register' || $('[data-auth-panel="register"] .form__err')) showAuth('register');
  }

  /* ---------- Collection filters ---------- */
  $$('[data-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });
  $$('[data-filter-form] input[type="checkbox"]').forEach(function (c) { c.addEventListener('change', function () { c.form.submit(); }); });

  /* ---------- Predictive search ---------- */
  $$('[data-predictive]').forEach(function (form) {
    var input = $('input[name="q"]', form), box = $('[data-predictive-results]', form), timer;
    if (!input || !box || !T.routes.predictive) return;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(function () {
        fetch(T.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
            box.innerHTML = ps.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_96x96$1$2') : (p.image || '');
              return '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '<div><b>' + esc(p.title) + '</b><span>' + money(Math.round(parseFloat(p.price) * 100)) + '</span></div></a>';
            }).join('') + '<a class="all" href="' + T.routes.search + '?q=' + encodeURIComponent(q) + '&type=product">See all results for “' + esc(q) + '”</a>';
            box.hidden = false;
          }).catch(function () { box.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
  });

  if (drawer) fetchCart();
})();
